var _path, _path2, _rect, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgFileVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "FileVideo_svg__lucide FileVideo_svg__lucide-file-video-camera-icon FileVideo_svg__lucide-file-video-camera"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 2v4a2 2 0 0 0 2 2h4"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 6,
  x: 2,
  y: 12,
  rx: 1
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m10 13.843 3.033-1.755a.645.645 0 0 1 .967.56v4.704a.645.645 0 0 1-.967.56L10 16.157"
})));

export default SvgFileVideo;